import { useState } from 'react';

export const Checkbox = ({ object, field, label, id }) => {

    const [, setTick] = useState(0);

    const handleChange = (e) => {
        object[field] = e.target.checked;
        setTick(tick => tick + 1);
    };

    return (
        <div className={'form-check'} id={'checkbox-box-' + id}>
            <label className={'form-check-label'} id={'checkbox-label-' + id}>
                <input
                    id={'checkbox-input-' + id}
                    className={'form-check-input'}
                    type='checkbox'
                    checked={object[field]}
                    onChange={handleChange}
                />
                {label}
            </label>
        </div>
    );
};